/* eslint-disable import/prefer-default-export */

import PropTypes from 'prop-types';


export const byIdShape = PropTypes.shape({
  [PropTypes.oneOfType([PropTypes.string, PropTypes.number])]: PropTypes.object,
});

export const latLngShape = PropTypes.shape({
  lat: PropTypes.number,
  lng: PropTypes.number,
});



// WEBPACK FOOTER //
// ./app/scripts/utils/propTypes.js